export function parseSecondsToReadable(seconds) {
    let s = seconds % 60;
    let m = Math.floor(seconds / 60) % 60;
    let h = Math.floor(seconds / 60 / 60);
  
    if (s <= 9) {
      s = '0' + s;
    }
  
    if (m <= 9) {
      m = '0' + m;
    }
  
    if (h <= 9) {
      h = '0' + h;
    }
  
    return `${h}:${m}:${s}`;
}

export function parseSecondsToReadableDate(seconds) {
    let d = Math.floor(seconds / (3600*24));
  
    return `${d} ` + Translator.trans('days');
  }